import { useCallback, useEffect, useRef, useState } from "react";

import { getRoleDetail } from "@/api/system/roles";

/**
 * 按角色 ID 拉取已绑定菜单 ID 列表
 * @param roleId 角色 ID，为空时不请求
 */
export const useRoleMenuIds = (roleId?: string) => {
  // 已选菜单 ID
  const [menuIds, setMenuIds] = useState<string[]>([]);
  // 菜单 ID 加载中
  const [loading, setLoading] = useState(false);
  const requestIdRef = useRef(0);

  /** 按角色 ID 请求详情中的 menuIds */
  const loadMenuIds = useCallback(async (id: string) => {
    const requestId = ++requestIdRef.current;
    setLoading(true);
    try {
      const res = await getRoleDetail(id);
      if (requestId !== requestIdRef.current) return;
      setMenuIds(res.data?.menuIds ?? []);
    } catch {
      if (requestId !== requestIdRef.current) return;
      setMenuIds([]);
    } finally {
      if (requestId === requestIdRef.current) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    if (!roleId) {
      requestIdRef.current += 1;
      setMenuIds([]);
      setLoading(false);
      return;
    }
    void loadMenuIds(roleId);
  }, [loadMenuIds, roleId]);

  return { menuIds, loading };
};
